import React, { useEffect } from 'react'
import Slider from '../components/Slider'
import Trustedsection from '../components/Trustedsection'
import NotificationBar from '../components/NotificationBar'
import AboutSection from '../components/AboutSection'
import TeamSlider from '../components/TeamSlider'
import Applications from '../components/ApplicationsSlider'
import SuccessSlider from '../components/SuccessSlider'
import TestimonialsSlider from '../components/TestimonialsSlider'
import CompanyLogoSlider from '../components/CompanyLogoSlider'
import HeroSection from '../components/HeroSection'
import FaqSection from '../components/FaqSection'
import ContactHome from '../components/ContactHome'
import VideoCards from '../components/VideoCard'
import Video from '../components/Video'
import { useDispatch, useSelector } from 'react-redux'
import { allapiAction } from '../Redux/common/action'
import HomeSlider from '../components/HomeSlider'
import OurServices from '../components/OurServices'


function Home() {
     const dispatch = useDispatch();
     const get_home_all_pro = useSelector((state) =>
    state?.allapi?.get_home_all_pro ? state?.allapi?.get_home_all_pro : {}
  );
  useEffect(() => {
    dispatch(allapiAction.gethomePro({}));
    dispatch(allapiAction.getsliderList({ page: "home" }));
    // dispatch(allapiAction.getsliderList({ page: "home" }));
    // dispatch(allapiAction.getMarqueesList2({ page: "home" }));
  }, []);
    return (
        <div className='container-fluid'>
            <div className="row">
    <div className="" style={{ marginTop: '90px'}}>
            <HomeSlider />
          </div>
                {/* <Slider /> */}

                <NotificationBar />

                <Trustedsection />

                <AboutSection />

                <OurServices />

                <TeamSlider />

                <Applications />

                <TestimonialsSlider />

                <SuccessSlider />

                <ContactHome />

                <FaqSection />

                <VideoCards />
    {/* <div className=" ">
            <Video homedata={get_home_all_pro} />
           
          </div> */}
                <CompanyLogoSlider />

                <HeroSection />

            </div>
        </div>
    )
}

export default Home
